import { ShareProjectModal } from '@/components';
import { create, useModal } from '@ebay/nice-modal-react';

export const ShareDialog = create<{ templateCode: string }>((props) => {
  // props
  const { templateCode } = props;
  // modal
  const { remove } = useModal();
  return (
    <ShareProjectModal
      visible
      info={{
        resource_code: templateCode,
        resource_type: 1,
      }}
      onCancel={remove}
      onOk={remove}
    />
  );
});
